import { MuiPickersUtilsProvider, KeyboardDatePicker, KeyboardDatePickerProps } from '@material-ui/pickers'
import DateFnsUtils from '@date-io/date-fns'

type DatePickerProps = KeyboardDatePickerProps & {
  // we require id for a11y reasons
  id: string
}
const DatePicker = ({ id, value, ...datePickerProps }: DatePickerProps) => {
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <KeyboardDatePicker
        format="MM/dd/yyyy"
        invalidDateMessage={'Invalid date format'}
        minDateMessage="Date should not be before minimal date"
        maxDateMessage="Date should not be after maximal date"
        variant="inline"
        inputVariant="outlined"
        {...datePickerProps}
        id={id}
        value={value}
      />
    </MuiPickersUtilsProvider>
  )
}

export default DatePicker
